module.exports = __webpack_public_path__ + "img/home-nav-icon-08.4ec03bbd.png";